module.exports = __webpack_public_path__ + "static/media/12.ff4f023c.png";